import(/* webpackMode: "eager" */ "/app/apps/next/app/(tabs)/layout.tsx");
